import { User as Auth0UserInternal } from "@auth0/auth0-react";
import { create } from "zustand";
import { storageRemove, storageSavePrimitive } from "@/Util/localStorageHelpers";
import { User } from "@/Stub/V1";

export type Auth0User = Auth0UserInternal & { permissions: string[] };
type AuthStoreState = {
    auth0User?: Auth0User
    accessToken?: string
    authUser?: User
    impersonatedOrgId?: number
};

type AuthStoreActions = {
    setAuth0User: (auth0User?: Auth0User) => void
    setAccessToken: (accessToken?: string) => void
    setAuthUser: (authUser?: User) => void
    setImpersonatedOrgId: (organisationId?: number) => void
};

export const useAuthStore = create<AuthStoreState & AuthStoreActions>()((set) => ({
    auth0User: undefined,
    accessToken: undefined,
    authUser: undefined,
    impersonatedOrgId: undefined,
    setAuth0User: (auth0User) => set(
        () => ({ auth0User: auth0User })
    ),
    setAccessToken: (accessToken) => set(
        () => ({ accessToken: accessToken })
    ),
    setAuthUser: (authUser) => set(
        () => ({ authUser: authUser })
    ),
    setImpersonatedOrgId: (organisationId) => set(
        () => {
            if (organisationId) {
                storageSavePrimitive('impersonatedOrgId', organisationId);
            } else {
                storageRemove('impersonatedOrgId');
            }
            return { impersonatedOrgId: organisationId };
        }
    )
}));
